import { useTranslation } from "@impero-com/common/utils/i18n";
import { RateGauge } from "@impero-com/ui";

import * as theme from "./ControlHealthDonutRateWidget.css";
import { ControlHealthWidget } from "./ControlHealthWidget";

interface ControlHealthFrictionRateWidgetProps {
    frictionRate: number | null;
}

export function ControlHealthFrictionRateWidget({
    frictionRate,
}: ControlHealthFrictionRateWidgetProps) {
    const { t } = useTranslation();
    const percentage =
        frictionRate === null ? null : Math.round(frictionRate * 10) / 10;

    return (
        <ControlHealthWidget
            title={t("ControlHealth_FrictionRate_Label")}
            className={theme.card}
        >
            <RateGauge
                percentage={percentage}
                label={t("ControlHealth_FrictionRate_Label")}
            />
        </ControlHealthWidget>
    );
}
